import { useRef, useLayoutEffect } from 'react'
import { gsap } from 'gsap'

// Neutral-200 (#d5d4d2)
// Resting: 35% opacity — Active: 100% opacity
// Pure opacity wave, no scale, sine.inOut for smooth feel
const NEUTRAL_200 = '#d5d4d2'

export const TypingIndicator = () => {
  const dot1Ref = useRef<HTMLSpanElement>(null)
  const dot2Ref = useRef<HTMLSpanElement>(null)
  const dot3Ref = useRef<HTMLSpanElement>(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const dots = [dot1Ref.current, dot2Ref.current, dot3Ref.current]

      gsap.set(dots, { backgroundColor: NEUTRAL_200, opacity: 0.35 })

      // stepDuration: how long each fade takes
      // cycleDuration: gap between each dot's activation (slightly longer = tiny hold)
      const stepDuration = 0.45
      const cycleDuration = 0.5

      const tl = gsap.timeline({ repeat: -1 })

      // Ping-pong: 0 → 1 → 2 → 1 → (repeat)
      const sequence = [0, 1, 2, 1]

      sequence.forEach((activeIdx, step) => {
        const t = step * cycleDuration
        tl.to(
          dots[activeIdx],
          { opacity: 1, duration: stepDuration, ease: 'sine.inOut' },
          t
        )
        dots.forEach((dot, j) => {
          if (j !== activeIdx) {
            tl.to(
              dot,
              { opacity: 0.35, duration: stepDuration, ease: 'sine.inOut' },
              t
            )
          }
        })
      })
    })

    return () => ctx.revert()
  }, [])

  const dot = (ref: React.RefObject<HTMLSpanElement | null>) => (
    <span
      ref={ref as React.LegacyRef<HTMLSpanElement>}
      className="block rounded-full shrink-0"
      style={{ width: 10, height: 10, backgroundColor: NEUTRAL_200 }}
    />
  )

  return (
    <div className="flex items-center gap-1 p-3 bg-neutral-25 rounded-[12px] w-fit">
      {dot(dot1Ref)}
      {dot(dot2Ref)}
      {dot(dot3Ref)}
    </div>
  )
}
